import { passById, type PassId } from '../data/passes'

export function costPerDay(passId: PassId, dayCount: number): number | null {
  const price = passById(passId).priceUsd
  if (!price || dayCount <= 0) return null
  return price / dayCount
}

export function formatMoney(n: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: n >= 100 ? 0 : 2,
  }).format(n)
}
